import { render, staticRenderFns } from "./actualizarDatos.vue?vue&type=template&id=3fda961d&"
import script from "./actualizarDatos.vue?vue&type=script&lang=js&"
export * from "./actualizarDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports